import "./home.css";

import React from "react";

const Home = () => {
  return (
    <div className="home-container">
      <h1 className="home-title">Welcome to Turtle360</h1>
      <h2 className="home-sub-title">Presolv360’s Operations Portal</h2>
    </div>
  );
};

export default Home;
